document.addEventListener('DOMContentLoaded', function() {
  // ■ 1. 必要な要素をすべて取得
  const openButton = document.querySelector('.mobile-menu-button');
  const closeButton = document.querySelector('.mobile-menu-close-button');
  const menuModal = document.querySelector('.mobile-menu-modal');
  const menuLinks = document.querySelectorAll('.menu-image-link[href^="#"]');

  // ■ 2. メニューを開く処理
  function openMenu() {
    if (menuModal) {
      menuModal.classList.add('active');
      document.body.style.overflow = 'hidden'; // 背景をスクロールさせない
    }
    // ボタンの表示を切り替え
    if (openButton) {
      openButton.style.display = 'none'; // ハンバーガーメニューボタンを非表示
    }
    if (closeButton) {
      closeButton.style.display = 'block'; // 閉じるボタンを表示
    }
  }

  // ■ 3. メニューを閉じる処理
  function closeMenu() {
    if (menuModal) {
      menuModal.classList.remove('active');
      document.body.style.overflow = ''; // 背景のスクロールを元に戻す
    }
    // ボタンの表示を切り替え
    if (openButton) {
      openButton.style.display = 'block'; // ハンバーガーメニューボタンを表示
    }
    if (closeButton) {
      closeButton.style.display = 'none'; // 閉じるボタンを非表示
    }
  }

  // ■ 4. 各要素にイベントを割り当て
  // 開くボタンがクリックされたら、メニューを開く
  if (openButton) {
    openButton.addEventListener('click', openMenu);
  }

  // 閉じるボタンがクリックされたら、メニューを閉じる
  if (closeButton) {
    closeButton.addEventListener('click', closeMenu);
  }

  // モーダルの背景がクリックされたら、メニューを閉じる
  if (menuModal) {
    menuModal.addEventListener('click', function(e) {
      // クリックされたのが背景自体の場合のみ閉じる
      if (e.target === this) {
        closeMenu();
      }
    });
  }
  
  // メニュー内のアンカーリンクがクリックされた時のスムーススクロール処理
  menuLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href');
      const targetSection = document.querySelector(targetId);
      
      if (targetSection) {
        // リンクをクリックしたら、まずメニューを閉じる
        closeMenu();
        
        // 少し待ってからスクロールする
        setTimeout(() => {
          targetSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }
    });
  });
});